export default __webpack_public_path__ + "static/media/magazine.35fd868c.jpg";